<div class="mt-2">
  <modus-label class="text-xs font-bold">
    {{ translations.reference.title.text }} ({{ lengthUnit() }})
  </modus-label>
</div>

<div class="text-xs mt-1">
  <div class="flex items-center pt-1">
    <sd-scan-3d-length-input
      [scan3dStyleUom]="scan3dStyleUom()"
      [formControl]="formGroup.controls.reference"
    ></sd-scan-3d-length-input>

    <button
      id="3d-style-elevation-picking-toggle"
      modus-icon-button
      class="ml-1 text-gray-8"
      [ngClass]="{ '!bg-blue-light !text-white': elevationPicking() }"
      [modus-tooltip]="elevationPickingTooltip()"
      (click)="onElevationPickClick()"
    >
      <md-icon>location</md-icon>
    </button>
  </div>

  @if (errorReference) {
    <div class="text-red mt-1 ml-1">
      {{ translations.reference.error.text }}
    </div>
  }
</div>

<div class="mt-3 text-xs">
  <modus-label class="font-bold">
    {{ translations.offset.title.text }} ({{ lengthUnit() }})
  </modus-label>

  <sd-scan-3d-length-input
    class="mt-1"
    [scan3dStyleUom]="scan3dStyleUom()"
    [formControl]="formGroup.controls.offset"
  ></sd-scan-3d-length-input>

  @if (errorOffset) {
    <div class="text-red mt-1 ml-1">
      {{ translations.offset.error.text }}
    </div>
  }
</div>

<div class="mt-3 text-xs">
  <modus-label class="font-bold">
    {{ translations.tolerance.title.text }} ({{ lengthUnit() }})
  </modus-label>

  <sd-scan-3d-length-input
    class="mt-1"
    [scan3dStyleUom]="scan3dStyleUom()"
    [formControl]="formGroup.controls.tolerance"
  ></sd-scan-3d-length-input>

  @if (errorTolerance) {
    <div class="text-red mt-1 ml-1">
      {{ translations.tolerance.error.text }}
    </div>
  }
</div>

<div class="mt-2 flex w-full items-center">
  <modus-label class="text-xs grow font-bold">
    {{ translations.bandCount.text }} ({{ scan3dStyle().elevationBandCount }})
  </modus-label>

  <mat-slider id="3d-style-elevation-band-count" [min]="1" [max]="9" [step]="1" class="mx-1">
    <input modus-input matSliderThumb [formControl]="formGroup.controls.bandCount" />
  </mat-slider>
</div>

<div>
  <modus-label class="text-xs font-bold">{{ translations.legend.title.text }}</modus-label>

  <div class="mt-2">
    <div class="flex justify-between text-xs mb-1">
      <span>{{ translations.legend.belowReference.text }}</span>
      <span>{{ translations.legend.reference.text }}</span>
      <span>{{ translations.legend.aboveReference.text }}</span>
    </div>

    <div class="relative">
      <div class="border border-gray-300 rounded overflow-hidden h-5">
        <div class="flex h-full w-full">
          @for (color of elevationGradient(); track $index) {
            <div class="h-full min-w-[1px] grow" [style.background-color]="color"></div>
          }
        </div>
      </div>

      <!-- Triangle indicators -->
      <div class="absolute top-full left-0 w-full">
        @for (band of elevationGradient(); track $index) {
          <div
            class="absolute top-0"
            [style.left]="($index / elevationGradient().length) * 100 + '%'"
            [style.width]="100 / elevationGradient().length + '%'"
          >
            <!-- First tolerance triangle -->
            @if ($index === 2) {
              <div class="flex flex-col items-start -ml-1">
                <ng-container [ngTemplateOutlet]="triangle"></ng-container>
              </div>
            }

            <!-- Middle reference triangle - around the center/black strip area -->
            @if ($index === middleGradientIndex()) {
              <div class="flex flex-col items-center transform -translate-x-1/2">
                <ng-container [ngTemplateOutlet]="triangle"></ng-container>
              </div>
            }

            <!-- Last tolerance triangle -->
            @if ($index === elevationGradient().length - 2) {
              <div class="flex flex-col items-start -ml-1">
                <ng-container [ngTemplateOutlet]="triangle"></ng-container>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="flex justify-between text-xs mt-2">
      <span>-{{ toleranceText() }}</span>
      <span>{{ referenceText() }}</span>
      <span>+{{ toleranceText() }}</span>
    </div>
  </div>
</div>

<!-- Reusable Triangle Template -->
<ng-template #triangle>
  <div
    class="w-0 h-0"
    style="
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 6px solid #374151;
    "
  ></div>
</ng-template>
